import { Component, OnInit } from '@angular/core';
import { UtilService } from '@app/utility/util.service';
import { ApiService } from '@app/utility/api.service';
import { Router, ActivatedRoute } from '@angular/router';

declare var $: any,moment : any
@Component({
  selector: 'app-create-new-password',
  templateUrl: './create-new-password.component.html',
  styleUrls: ['./create-new-password.component.scss']
})
export class CreateNewPasswordComponent implements OnInit {

  constructor(
    private util: UtilService,
    private apiService: ApiService,
    private router: Router,
    private activatedRoute: ActivatedRoute
  ) { }

  isExistingUser = true

  token = ""

  roleData: any
  returnUrl = ""
  submitted = false
  username = ""
  pin = ""
  userId=""
  newPass = ""
  confirmPass = ""
  oldPassword = "";
  isResetSuccess = false
  isConfirmPinSuccess = false
  tmpUsername = ""
  tmpNewPass = ""

  ngOnInit() {

    //let cookieData = JSON.parse(localStorage.getItem("dpa_cc"))
    //this.username = cookieData["username"]
    //this.userId = cookieData["userId"]

    //this.roleData = JSON.parse(localStorage.getItem("role"))
    //this.returnUrl = localStorage.getItem("returnUrl")
   
    $("#createPass").addClass("sr-only");
  }

  async validateToken(){
    let req = {
      token_id: this.token
    }
    let res: any = await this.apiService.postCustom("Crm", "GetUsernameFromToken", req)
    if(this.util.isSuccessResponse(res)){
      this.username = res.username
      this.token = res.token_id
      this.isExistingUser = true
    }
    else{
      this.util.ErrorDialog("ไม่พบข้อมูลการขอกำหนดรหัสผ่าน กรุณาลองใหม่อีกครั้ง")
    }
  }

  async confirmPin(){
    this.submitted = true
    if (this.pin.length > 0){
      this.util.ShowWaiting(true)

      let para = "pin=" + this.pin
      let user: any = await this.apiService.get("crmservice", "getUserCallCenterByPin", para)
      if (user.username != null) {
        this.util.ShowWaiting(false)
        this.username = user.username
        
        $("#divPin").addClass("sr-only");
        
        $("#createPass").removeClass("sr-only");
      }else {
        this.util.ShowWaiting(false)
        this.util.ErrorDialog("รหัส Pin ผืดพลาด กรุณาตรวจสอบใหม่อีกครั้ง")
      }
    }
  }

  async changePassword() {
    this.submitted = true
    if (this.newPass.length > 0 && this.newPass == this.confirmPass
      && this.passwordValidation()) {
      this.util.ShowWaiting(true)

      let guidReq: any = {
        username: this.username
      }
      let guidRes: any = await this.apiService.postCustom("Crm", "InsertChangeCallCenterPassToken", guidReq);
      if (this.util.isSuccessResponse(guidRes) && guidRes.token_id != "")
      {
        this.token = guidRes.token_id
      }

      let para = "username=" + this.username
      let user: any = await this.apiService.get("crmservice", "callcenterProfile", para)

      if (user != null && user.length > 0) {
        if (user[0].dpa_customwebuserid != null && user[0].dpa_customwebuserid.toString().trim().length != 0) {
          let guidReq: any = {
            dpa_customwebuserid: user[0].dpa_customwebuserid,
            guid: this.token
          }
          this.oldPassword = user[0].dpa_password;
          
          if (this.oldPassword == this.newPass) {
            this.util.ErrorDialog("เปลี่ยน Password ไม่สำเร็จ password ต้องไม่เท่ากับ password เดิม")
          } else {

            let guidRes: any = await this.apiService.post("crmservice", "updateCallcenterGuid", guidReq);
            if (this.util.isSuccessResponse(guidRes) && guidRes.RESMSG == "SUCCESS") {
              let req: any = {
                //username: this.username,
                newPassword: this.newPass,
                //forcechangepassword: true,
                guid: this.token
              }

              var res: any = await this.apiService.put("crmservice", "callcenterChangepassword/" + this.username, req);
              if (this.util.isSuccessResponse(res) && res.RESMSG == "SUCCESS") {
                this.isResetSuccess = true
                this.clear()
                this.username = ""
                
                this.util.ShowWaiting(false)
                this.util.SuccessDialog("เปลี่ยน Password สำเร็จ")
                let thisTs = this
                $('#btnSuccessOK').on('click', function () {
                  
                  thisTs.router.navigate(['login']);
                });

               
                //this.DeleteToken(this.token);
                //this.router.navigate(['login']);
              }
              else {
                this.util.ShowWaiting(false)
                this.util.ErrorDialog("เปลี่ยน Password ไม่สำเร็จ")
              }
            }
            else {
              this.util.ShowWaiting(false)
              this.util.ErrorDialog("เปลี่ยน Password ไม่สำเร็จ")
            }
          }
          
        }
      }else{
        
        this.util.ShowWaiting(false)
      }
    }
  }

  clear() {
    this.submitted = false
    this.newPass = ""
    this.confirmPass = ""
  }
  
  clearPin() {
    this.submitted = false
    this.pin = ""
  }

  close() {
    window.close()
  }

  passwordValidation() {
    return /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,16}$/.test(this.newPass)
  }

  DeleteToken(TokenID: any) {
    let ParamObj: any = {
      token_id: TokenID
    };
    this.apiService.postCustom("user", "deletetoken", ParamObj);
  }
}



// WEBPACK FOOTER //
// ./src/app/create-new-password/create-new-password.component.ts